// 法语
export default {
  locale: "fr",
  language: "Français",
  menu: {
    i18n: "Multilingue"
  },
  page: {
    content: {
      MoreAndMore: "更多(法语)",
      loginTip: "您尚未登录 请先登录(法语)",
      blockNoData: "暂无更多公告(法语)",
      supplierPortal: "首页(法语)",
      projectCode: "项目编号(法语)",
      publishTime: "发布时间(法语)",
      labelMenu1: "评标结果(法语)",
      labelMenu2: "流标公告(法语)",
      labelMenu3: "补遗公告(法语)",
      labelMenu4: "邀请公告(法语)",
      labelMenu5: "中标通知(法语)",
      labelMenu6: "招标采购(法语)",
      labelMenu7: "询价采购(法语)",
      labelMenu8: "竞争谈判(法语)",
      labelMenu9: "邀请竞价(法语)",
      labelMenu10: "公开询价(法语)",
      labelMenu11: "公开竞价(法语)",
      projectNamePlaceholder: "请输入项目名称(法语)",
      search: "搜索(法语)",
      allClassify: "全部分类(法语)",
      menu1: "首页(法语)",
      menu2: "集中采购(法语)",
      menu3: "区域联采(法语)",
      menu4: "供应商注册(法语)",
      menu5: "供应链金融(法语)",
      menu6: "业务协同(法语)",
      Hello: "您好(法语)",
      welcomeToBack: "Hi,欢迎回来(法语)",
      loginText: "登录交建云商(法语)",
      Exit: "退出(法语)",
      supplierLogin: "供应商登录(法语)",
      pleaseLogin: "请登录(法语)",
      Announcements: "通知公告(法语)",
      purchase: "采购(法语)",
      projectName: "项目名称(法语)",
      searchPlaceholder: "搜索 项目公告(法语)",
      packageNum: "包件数量(法语)",
      fromEndTime: "距离结束(法语)",
      viewDetail: "查看详情(法语)",
      downLoad: "下载(法语)",
      to: "至(法语)",
      startTime: "开始时间(法语)",
      endTime: "结束时间(法语)",
      joinStatus: "参与状态(法语)",
      title: "标题(法语)",
      titlePlaceholder: "请输入标题模糊查询(法语)",
      serialNo: "序号(法语)",
      publishUnit: "发布单位(法语)",
      signUpEndTime: "报名结束剩余时间(法语)",
      day: "天(法语)",
      hour: "时(法语)",
      minute: "分(法语)",
      second: "秒(法语)",
      immediatelySignUp: "立即报名（仅供应商可报名）(法语)",
      toMyProject: "进入项目(法语)",
      notice: "公告(法语)",
      noticeTitle: "公告标题(法语)",
      noticeContent: "公告内容(法语)",
      contractInfo: "联系信息(法语)",
      fileList: "附件列表(法语)",
      supplierBiddingProcess: "供应商投标操作流程(法语)",
      pleaseClickView: "请点击查看(法语)",
      packageDesc: "包件说明(法语)",
      materialInfo: "物资信息(法语)",
      relatedNoticeList: "相关公告列表(法语)",
      purchaseMoney: "采购金额(法语)",
      thousandYuan: "万元(法语)",
      camulativePurchaseItems: "累计招标项目(法语)",
      inquiryProjectNum: "询价项目数量(法语)",
      biddingProjectNum: "竞谈项目数量(法语)",
      unitStillPurchase: "该单位还在采购(法语)",
      fileName: "附件名称(法语)",
      fileDesc: "附件说明(法语)",
      operation: "操作(法语)",
      equipmentName: "设备物资名称(法语)",
      equipmentDesc: "设备物资说明(法语)",
      num: "数量(法语)",
      unit: "单位(法语)",
      type: "类型(法语)",
      link: "环节(法语)",
      other: "其他(法语)",
      aboutUs: "关于我们(法语)",
      introPlatform: "平台简介(法语)",
      contactUs: "联系我们(法语)",
      relevantPoliciesAndRegulations: "相关政策与规范(法语)",
      purchaser: "采购方(法语)",
      operationGuide: "操作指引(法语)",
      videoTutorial: "视频教程(法语)",
      supplier: "供应商(法语)",
      supplierName: "供应商名称(法语)",
      netInformation: "入网须知(法语)",
      commonProblem: "常见问题(法语)",
      purchaseCommonProblem: "采购方常见问题(法语)",
      supplierCommonProblem: "供应商常见问题(法语)",
      serviceCenter: "服务中心(法语)",
      onlineCounsel: "在线咨询(法语)",
      afterSalesService: "售后服务(法语)",
      feedback: "意见反馈(法语)",
      fileTemplateDownload: "文件模板下载(法语)",
      supplyChainFinanceCenter: "供应链金融中心(法语)",
      officialWeChat: "官方微信(法语)",
      navigation: "栏目导航(法语)",
      source: "来源(法语)",
      add: "新增(法语)",
      author: "作者(法语)",
      publishDate: "发布日期(法语)",
      all: "全部(法语)",
      prev: "< 上一页(法语)",
      next: "下一页 >(法语)",
      sure: "确定(法语)",
      noRelatedData: "暂无相关数据(法语)",
      supplierOperationManual: "供应商操作手册(法语)",
      operationManual: "操作手册(法语)",
      supplierOperationGuide: "供应商操作指南(法语)",
      noData: "暂无数据(法语)",
      question: "业务流程及常见问题(法语)",
      purchaseType: "采购方式(法语)",
      materialClassify: "物资分类(法语)",
      multiSelect: "多选(法语)",
      cancel: "取消(法语)",
      onlySupplierLogin: "仅供应商登录可选(法语)",
      publicBidding: "公开招标(法语)",
      publicInquiry: "公开询价(法语)",
      publicOutcry: "公开竞价(法语)",
      inquiry: "询价采购(法语)",
      inviteBidd: "邀请竞价(法语)",
      competitiveNegotiation: "竞争性谈判(法语)",
      invitationTender: "邀请招标(法语)",
      nearly3Days: "近3天(法语)",
      nearly7Days: "近一周(法语)",
      nearly30Days: "近一个月(法语)"
    },
    sup: {
      title: "Guide d'utilisation des fournisseurs",
      content1: "中国交建电子采购平台 —— 供应商门户（(法语)",
      content2:
        "）是供应商加入中国交通建设集团有限公司（以下简称“中国交建”）供应商网络的唯一合法的电子商务网站。中国交建按照“互利共赢、诚信合作”的原则，与供应商建立积极的合作关系。(法语)",
      content3:
        "中国交建对供应商实行准入管理，经准入的供应商具备参与中国交建及所属企业的线上投标和报价资格。凡有意参与中国交建采购业务的供应商均须认真阅读入网须知及注册指南，选择(法语)",
      content4:
        "注册（推荐单位为供应商信息的初审单位），经审核通过后入网。(法语)",
      content5: "请为保证系统的稳定兼容性，请使用(法语)",
      content6:
        "或以上版本的IE浏览器（同时选择兼容模式），以获得最佳效果。设置方法参见：(法语)",
      contentStrong: "Recommandé par",
      questions: "FAQ Questions fréquemment posées",
      explain: "其他说明如下：(法语)",
      explain1: "1. Avis d'inscription",
      explain2: "2. 注册流程(法语)",
      explain3: "3. FAQ Questions fréquemment posées",
      explain4: "4. Notice d'utilisation",
      explain5: "5. 如何找回密码(法语)",
      explain6: "6. 供应商在线投标重要提示及操作流程(法语)",
      supNetInformation: "Avis d'inscription",
      netInformation1:
        "1.中国交通建设集团有限公司设备物资采购管理信息平台是供应商加入中国交通建设集团有限公司（以下简称“中国交建”）供应商网络的唯一合法网站。中国交建按照“互利共赢、诚信合作”的原则，与供应商建立积极的合作关系。(法语)",
      netInformation2:
        "2.中国交通建设集团有限公司对申请入网的供应商不收取任何费用，不颁发相关证书，也不以年审、会员制、业绩考核等名义向供应商收取费用。供应商填写入网信息必须真实、准确并及时更新。(法语)",
      netInformation3:
        "3. 如遇系统升级，平台运营方有权延长招标结束时间、售标结束时间。(法语)",
      faqName: "供应商在线投标重要提示及操作流程(法语)",
      createUserName: "中国交通建设集团有限公司(法语)",
      releaseMechanism: "发布机构：(法语)",
      releaseTime: "发布时间：(法语)",
      titleContent:
        "为保障招标活动的顺利进行，请投标供应商认真阅读以下内容：(法语)",
      titleContent1:
        "一、避开投标高峰时间：高峰时间（8:00—18:00），特别是投标截止日前一天。(法语)",
      titleContent2:
        "二、控制投标文件大小：投标文件应控制在30M以内，为避免提交标书时上传速度慢，影响文件的递交，请尽量压缩投标文件和图片尺寸。(法语)",
      titleContent3:
        "三、投标操作：建议供应商避开高峰时间投标，可采用分步上传技术投标文件和商务报价函（先上传技术投标文件）的方法。(法语)",
      titleContent4: "四、具体演示：(法语)",
      operationProcess: "供应商投标操作流程(法语)",
      clickOnTitleToView: "点击标题查看(法语)",
      table: {
        title: "附件列表(法语)",
        serialNumber: "Numéro de série", //序号
        fileName: "nom de la pièce jointe", //附件名称
        fileSize: "Taille de la pièce jointe",
        fileDesc: "Description de la pièce jointe", //附件说明
        operation: "opération", //操作
        upload: "下载(法语)"
      },
      dialog: {
        title: "关于供应商在线投标的重要提示(法语)",
        dialogTitle:
          "为保障招标活动的顺利进行，请投标供应商认真阅读以下内容：(法语)",
        content1: "一、避开投标高峰时间(法语)",
        contentP1: "高峰时间（每日6:00—18:00），特别是投标截止日前一天。(法语)",
        content2: "二、控制投标文件大小(法语)",
        contentP2:
          "投标文件应控制在30M以内，为避免提交标书时上传速度慢，影响文件的递交，请尽量压缩投标文件。(法语)",
        content3: "三、投标操作",
        contentP3:
          "建议供应商避开高峰时间投标，可采用分步上传技术投标文件和商务报价函（先上传技术投标文件）的方法。投标操作具体演示如下：(法语)",
        participateInBidd: "1.参与招标(法语)",
        participateInBiddCont1:
          "1)使用IE浏览器登陆供应商门户网站（https://sp.iccec.cn）(法语)",
        participateInBiddCont2:
          "2)登陆后点击邀请公告。点击一条公告进入后，网页下方有一个参与按钮，点击进入填写联系信息并提交。此时系统会提示您已“报名成功”。(法语)",
        biddingDocuments: "2.下载招标文件(法语)",
        biddingDocumentsCont1:
          "1)招标人收到标书费用，会通过系统给供应商发送招标文件，您在待办提醒里可以看到采购文件下载(法语)",
        biddingDocumentsCont2:
          "2)待办提醒还可以提供答疑、投标、补遗、澄清等信息。(法语)",
        tender: "3.投标",
        tenderCont1: "1)投标阶段开始后请查看待办提醒，点击。(法语)",
        tenderCont2:
          "2)供应商也可以点击供应商门户地址栏下方的业务协同，进入您的工作界面。(法语)",
        tenderCont3:
          "3)进入工作界面后，页面左侧有您参与的方案，点击方案后进入投标菜单进行投标。(法语)",
        tenderCont4:
          "4）为避免附件大造成投标失败，建议在投标结束前一天完成网上投标。(法语)",
        tenderCont5:
          "您也可以分步上传标书文件，首先填写报价表，并上传技术投标文件，点击提交按钮；此时系统提示(法语)",
        aTender: "投标成功(法语)",
        tenderCont6: "在商务报价表做好后，在投标菜单点击(法语)",
        tenderCont7:
          "按钮，修改报价，通过“上传”按钮把商务报价文件上传至系统后，点击提交完成最终报价。(法语)",
        tenderCont8:
          "备注：请不要点击撤销投标，点击后系统会删除所有投标文件。(法语)",
        reportAgain: "再次上报(法语)",
        toClarify: "4.澄清(法语)",
        toClarifyCont:
          "在评标阶段，招标方会通过系统发布澄清文件，请在待办提醒中查看并回复。(法语)",
        question: " 5.质疑(法语)",
        questionCont:
          "供应商如对招标文件有疑问，可通过点击首页的业务协同，在业务协同页面左侧找到参与的项目，点击参与的项目找到质疑答疑菜单，上传您的质疑文件，也可查看招标方答疑文件。(法语)",
        addendumFile: "6.查看补遗文件(法语)",
        addendumFileCont:
          "如果招标方发布补遗文件，您可以在首页的待办提醒里查看。(法语)",
        notes: "四、电子标书大小注意事项(法语)",
        notesCont1:
          "在制作投标文件的过程中，因投标书含有许多图片导致文件很大而影响上传。为避免提交标书时上传速度慢，请尽量压缩投标文件和图片尺寸，文件大小应控制在30M以内。也可以将Word文件转换为PDF格式并使用压缩包软件，压缩文件大小。(法语)",
        notesCont2: "1.转换为PDF格式有2种方法：(法语)",
        notesCont3:
          "1) 一种是在Word中直接另存为PDF格式，并压缩尺寸（含Office2007, 2010和2013版本）。(法语)",
        notesCont4:
          "2) 一种是安装PDF虚拟打印机，自动生成PDF文档。（Office2003不带PDF转换，就需要安装此软件，PDFCreator软件为开源软件，任何人都可以免费安装使用）。下载地址(法语)",
        click: "点击(法语)",
        notesCont5:
          "2.以下为Office 2007及以上版本直接另存为PDF格式的方法：(法语)",
        notesCont6:
          "1) 以Office2010为例，在Word文档中选择文件另存为，保存类型选择(法语)",
        notesCont7: "2) 在优化项选择“针对以下格式优化(法语)",
        notesCont8: "可将文件压缩至20M以内。(法语)",
        smallestFileSize: "最小文件大小(法语)",
        sure: "Confirmer", //确定
        cancel: "Annuler", //取消
        spread: "展开(法语)",
        shrinkage: "收缩(法语)"
      }
    },
    login: {
      title: "供应商登录(法语)",
      pwLogin: "密码登录(法语)",
      smsLogin: "短信登录(法语)",
      pleaseUn: "用户名/手机号(法语)",
      pleasePw: "请输入密码(法语)",
      loginName: "登录(法语)",
      smsSendSuccessTip1: "短信验证码已发送至(法语)",
      smsSendSuccessTip2: "请注意查收(法语)",
      telNo: "手机号(法语)",
      smsVerCode: "短信验证码(法语)",
      sendVerCode: "发送验证码(法语)",
      sended: "已发送(法语)",
      jjt: "交建通(法语)",
      wx: "微信(法语)",
      Copyright: "Copyright © 2018 中国交建 All rights reserved.",
      statement: "最终解释权：闽ICP备2022005227号-2 中国交建(法语)",
      acApiErrorObj: {
        error1: "该登录账号因无效登录超过6次已被锁定30分钟(法语)",
        error2: "未实名(法语)",
        error3: "登录账号已被冻结(法语)",
        error4: "系统服务暂不可用，请稍后重试(法语)"
      },
      pwApiErrorObj: {
        error1: "登录账号与登录密码不匹配，请重新输入(法语)",
        error2: "请滑动完成验证(法语)"
      },
      telErrorObj: {
        error1: "请输入正确的手机号(法语)",
        error2: "手机号与短信密码不匹配，请重新输入。(法语)",
        error3: "手机号短信验证码无效登录6次，将锁定手机号30分钟(法语)",
        error4: "系统服务暂不可用,请稍后重试(法语)"
      },
      smsSliderErrorObj: {
        error1: "请滑动完成验证(法语)"
      },
      smsErrorObj: {
        error1: "请勿重复发送，倒计时完成后可再次获取验证码(法语)",
        error2: "发送验证码失败,请稍后再试(法语)"
      },
      upLang: {
        _startTEXT: "请按住滑块，拖动到最右侧(法语)",
        _yesTEXT: "验证通过(法语)",
        _noTEXT: "验证不通过(法语)",
        _error300:
          '哎呀，出错了，点击<a href="javascript:__nc.reset()">刷新</a>再来一次(法语)',
        _errorNetwork:
          '网络不给力，请<a href="javascript:__nc.reset()">点击刷新</a>(法语)'
      }
    },
    retrievePassword: {
      retrievePassword: "取回密码",
      title: "在线取回用户名密码",
      content1: "首先下载并填写",
      content2: "《供应商用户名及密码找回申请表》",
      downLoad: "点击下载",
      content3:
        "，需加盖单位公章并扫描，然后把申请表扫描件和营业执照扫描件上传到系统。提交用户及密码找回申请，申请由管理员审批通过后，系统自动把申请找回的用户名及随机密码发送至您填写的邮箱，根据邮件信息登录系统重置随机密码。",
      supName: "供应商名称：",
      holderSupName: "请输入供应商名称",
      hintContent1: "供应商用户名，密码取回联系人及联系方式：",
      hintContent2:
        "（注：申请人信息须与申请表中申请人信息一致，该申请人不一定是注册联系人。）",
      contactName: "申请人姓名：",
      holderContactName: "请输入申请人姓名",
      contactMobile: "申请人手机：",
      holderContactMobile: "请输入申请人手机",
      effectiveMobile: "请输入有效的手机号码",
      hintContent3: "接收用户名及密码的真实有效邮箱：",
      hintContent4:
        "（注：请填写真实有效的邮箱，申请信息审批通过后，会把用户名及随机密码发送至该邮箱。该邮箱不一定是注册联系人邮箱。）",
      email: "E-mail地址：",
      holderEmail: "请输入E-mail地址",
      effectiveEmail: "请输入正确的邮箱地址",
      fileinfoTypeName: "名称",
      fileinfoType1: "供应商用户名及密码找回申请表扫描件",
      fileinfoType2: "供应商营业执照扫描件",
      fileType: "类型",
      fileTypeName: "图片",
      fileName: "文件",
      operation: "操作",
      upload: "上传",
      delete: "删除",
      downloadSampleTable: "样表下载",
      submit: "提交",
      reset: "重置",
      confirmTitle1: "您的供应商密码取回申请提交成功，请注意查收邮件或短信",
      confirmHint: "提示",
      ascertain: "确定",
      confirmTitle2: "请您上传附件后提交申请！",
      fileSuccess: "附件上传成功",
      uploadError: "上传出错，请联系管理员",
      confirmTitle3: "供应商名称的输入有误！请输入，该项不能为空或空格",
      confirmTitle4: "供应商名称不存在，请输入正确的供应商名称！",
      fileSizeNO50: "文件大小不可超过50M！",
      uploadBmpError: "上传文件格式错误！"
    }
  }
};
